import { SetLocalHeader } from "../header";
import { getPageSettings } from "./pageSettings";
import { modifyAllApplyLocalHref } from "./share";

export class HeaderSwitch {
    private static instance: HeaderSwitch;
    static getInstance(): HeaderSwitch {
        if (!HeaderSwitch.instance) {
            HeaderSwitch.instance = new HeaderSwitch();
        }
        return HeaderSwitch.instance;
    }
    constructor() {
       this.init();
    }
    init(){
            const isLocalized:boolean = localStorage.getItem('dbaName') !== null;
            if(!isLocalized)
                return;
          
            const pageScope = getPageSettings('pagescope');
            // Desktop-only swap: on mobile .brand-header renders the drawer utility section, while .brand-header-local is display:none below 1024px.
            if(isLocalized && pageScope === 'national' && window.innerWidth >= 1024)
                this.initalizeVDOM();

    }

    initalizeVDOM(){
        const header = document.querySelector('.header-wrapper') as HTMLElement;
        const nationaDom = document.querySelector('.brand-header') as HTMLElement;
        const localDom = document.querySelector('.brand-header-local') as HTMLElement;
        if(!nationaDom || !localDom || !header)
            return;
        this.handleDOMLoaded();
    }


private async handleDOMLoaded(): Promise<void> {
    const oldBrandHeader = document.querySelector(".brand-header");

    // Select the local brand header
    const newBrandHeader = document.querySelector(".brand-header-local") as HTMLElement;

    if (oldBrandHeader && newBrandHeader) {    
        const clonedNewBrandHeader = newBrandHeader.cloneNode(true) as HTMLElement;
        const mainHeader = document.querySelector('.main-header');
        if (mainHeader?.classList?.contains('compressed-header')) {
            clonedNewBrandHeader.style.display = '';
        } else {
            clonedNewBrandHeader.style.display = 'flex'; // Ensure the local header is visible
        }
        oldBrandHeader.replaceWith(clonedNewBrandHeader);  
        modifyAllApplyLocalHref();
         //Removing the local header
         newBrandHeader.remove();
          const setLocalHeader = new SetLocalHeader();
          await setLocalHeader.initAsync();
    } 
}
}




